import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store/index.js'
import Util from './../util/util.js'
/**
 * 重写路由的push方法
 * 解决相同路由跳转时报错
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  if (typeof (location) === 'string') {
    var Separator = '&'
    if (location.indexOf('?') === -1) { Separator = '?' }
    location = location + Separator + 'random=' + Math.random()
  }
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)

function redirectHandle(navData) { // 根据权限动态更换重定向路径
  var urlArr = navData.menuUrl
  var leftUrl = JSON.parse(JSON.stringify(urlArr)) // 深拷贝
  var permissions = localStorage.getItem('permissions') // 权限
  if (permissions) {
    // 权限处理
    var newLeftNav = Util.judgePermissions(leftUrl, permissions.split(','))
    // 判断第一个导航是否拥有子导航，如果有则重定向子导航第一个，如果没有则重定向导航第一个
    if (newLeftNav[0].children.length) {
      return newLeftNav[0].children[0].url
    } else {
      return newLeftNav[0].url
    }
  }
}
// 如何根据权限重定向
// const title = '宅小取门店管理端'
document.title = '宅小取门店管理端'

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/Login.vue'),
    },
    {
      path: '/activePage',
      name: 'ActivePage',
      component: () => import('@/views/login/ActivePage.vue'),
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import('@/views/login/NotFound.vue'),
    },

    {
      path: '/401',
      name: '401',
      component: () => import('@/views/login/401.vue'),
    },
    {
      path: "/econmicKanban",
      name: "EconmicKanban",
      component: () => import('@/views/gloabView/econmicKanban.vue'),
    },
    {
      path: "/carbonNeutralDaping",
      name: "CarbonNeutralDaping",
      component: () => import('@/views/gloabView/carbonNeutralDaping.vue'),
    },
    {
      path: '/',
      name: 'Main',
      component: () => import('@/views/Main.vue'),
      children: [

        /* 从这里开始是新的项目内容 */
        {
          path: '/',
          redirect: '/orderList'
          // name: 'OrderList',
          // component: () => import('@/views/orderManagement/orderList/OrderList.vue')
        },
        // 邮寄订单
        {
          path: '/tradeOrderList',
          name: 'TradeOrderList',
          component: () => import('@/views/orderManagement/orderList/TradeOrderList.vue'),
        },
        // 以旧换新
        {
          path: '/sendPostOrderList',
          name: 'SendPostOrderList',
          component: () => import('@/views/orderManagement/orderList/sendPostOrderList.vue'),
        },
        // 物流订单
        {
          path: '/logisticsList',
          name: 'LogisticsList',
          component: () => import('@/views/orderManagement/orderList/logisticsList.vue'),
        },
        // 线下订单
        {
          path: '/offLinePage',
          name: 'OffLinePage',
          component: () => import('@/views/orderManagement/orderList/components/OffLinePage.vue'),
        },

        {
          path: '/orderList',
          name: 'OrderList',
          component: () => import('@/views/orderManagement/orderList/OrderList.vue'),

        },
        {
          path: '/orderForm',
          name: 'OrderForm',

          component: () => import('@/views/orderManagement/OrderForm/OrderForm.vue'),

        },
        {
          path: '/orderForm2',
          name: 'OrderForm2',

          component: () => import('@/views/orderManagement/OrderForm/OrderForm2.vue'),

        },
        {
          path: '/finishItem',
          name: 'FinishItem',
          component: () => import('@/views/orderManagement/orderList/FinishItem.vue'),
        },
        // 编辑完成订单
        {
          path: '/editOrder',
          name: 'EditOrder',
          component: () => import('@/views/orderManagement/orderList/EditOrder.vue'),
        }
        ,
        {
          path: '/calculateItem',
          name: 'CalculateItem',
          component: () => import('@/views/orderManagement/orderList/CalculateItem.vue')
        },
        {
          path: '/unfinishItem',
          name: 'UnfinishItem',
          component: () => import('@/views/orderManagement/orderList/UnfinishItem.vue')
        },
        //物流订单详情
        {
          path: '/logisticDetails',
          name: 'LogisticDetails',
          component: () => import('@/views/orderManagement/orderList/components/LogisticDetails.vue')
        },
        {
          path: '/offLineItem',
          name: 'OffLineItem',
          component: () => import('@/views/orderManagement/orderList/OffLineItem.vue')
        },

        // {
        //   path: '/categoryList',
        //   name: 'CategoryList',
        //   component: () => import('@/views/category/categoryList.vue')
        // },
        {
          path: '/clientList',
          name: 'ClientList',
          component: () => import('@/views/client/ClientList.vue')
        },
        // -----------------------------------------------------------
        // 门店列表页
        {
          path: '/storeList',
          name: 'StoreList',
          component: () => import('@/views/storeManagement/storeList/StoreList.vue')
        },
        // 添加门店
        {
          path: '/addstore',
          name: 'AddStore',
          component: () => import('@/views/storeManagement/addStore/AddStore.vue')
        },
        // 门店详情
        {
          path: '/storeDetails',
          name: 'StoreDetails',
          component: () => import('@/views/storeManagement/storeList/StoreDetails.vue'),
        },
        // 创建流程
        {
          path: '/createApproval',
          name: 'CreateApproval',
          component: () => import('@/views/storeManagement/components/Details/createApproval/createApproval.vue')
        },
        // ----------------------------
        // 店员
        {
          path: '/pickers',
          name: 'Pickers',
          component: () => import('@/views/picker/pickers.vue')
        },
        // 添加店员
        {
          path: '/addPricker',
          name: 'AddPricker',
          component: () => import('@/views/picker/addPricker/AddPricker.vue')
        },
        // 权限管理
        {
          path: '/competence',
          name: 'Competence',
          component: () => import('@/views/picker/competence/Competence.vue')
        },
        // 隐私政策
        {
          path: '/policy',
          name: 'Policy',
          component: () => import('@/views/policy/Policy.vue')
        },
        {
          path: '/outline',
          name: 'Outline',
          component: () => import('@/views/statistics/Outline.vue')
        },
        // 审批列表
        {
          path: '/approvalHome',
          name: 'ApprovalHome',
          component: () => import('@/views/approval/approvalHome.vue')
        },
        // 报销详情
        {
          path: '/reimbursementDetails',
          name: 'ReimbursementDetails',
          component: () => import('@/views/approval/reimbursementDetails.vue')
        },
        // 概览
        {
          path: '/allOreder',
          name: 'AllOreder',
          component: () => import('@/views/statistics/AllOreder.vue')
        },
        // 经营分析
        {
          path: '/operationAnalysis',
          name: 'OperationAnalysis',
          component: () => import('@/views/statistics/OperationAnalysis.vue')
        },
        //光荣榜
        {
          path: '/rankList',
          name: 'RankList',
          component: () => import('@/views/statistics/RankList.vue')
        },
        // 统计(报表功能)
        {
          path: '/journalingList',
          name: 'JournalingList',
          component: () => import('@/views/statistics/journaling/journalingList.vue')
        },
        // 减碳量
        {
          path: '/carbonReduction',
          name: 'CarbonReduction',
          component: () => import('@/views/statistics/carbonReductions/CarbonReduction.vue')
        },
        // 全局配置
        {
          path: '/deploy',
          name: 'Deploy',
          component: () => import('@/views/globlaConfiguration/deploy.vue')
        },
        // 门店地图
        {
          path: '/storeMaps',
          name: 'StoreMaps',
          component: () => import('@/views/storeMap/storeMaps.vue')
        },
        // 目标成本
        {
          path: '/targetCost',
          name: 'TargetCost',
          component: () => import('@/views/statistics/componenets/TargetCost.vue')
        },
        // 目标利润
        {
          path: '/profitTarget',
          name: 'ProfitTarget',
          component: () => import('@/views/statistics/componenets/ProfitTarget.vue')
        },
        {
          path: '/orderFinishItem',
          name: 'OrderFinishItem',
          component: () => import('@/views/statistics/componenets/OrderFinishItem.vue')
        },
        {
          path: '/orderUnFinishItem',
          name: 'OrderUnFinishItem',
          component: () => import('@/views/statistics/componenets/OrderUnFinishItem.vue')
        },
      ]
    },
  ]
})
// const VueRouterPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }
/**
  * 路由守卫
  */
router.beforeEach((to, from, next) => {
  // console.log(to.path)
  // 获取本地 token
  if (localStorage.getItem('accessToken') && localStorage.getItem('refreshToken')) {
    let token = {
      accessToken: localStorage.getItem('accessToken'),
      refreshToken: localStorage.getItem('refreshToken'),
    }
    store.dispatch('setToken', token)
  }
  // 获取登录名称
  if (localStorage.getItem('loginName')) {
    store.dispatch('setLoginName', localStorage.getItem('loginName'))
  }
  // 获取权限
  const permissionsArr = localStorage.getItem('permissions')
  if (permissionsArr) {
    store.dispatch('setPermissions', permissionsArr.split(','))
  }
  if (to.path === '/welcome' || to.path === '/home') {
    sessionStorage.setItem('parentActivePath', '/welcome')
  }
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title + '-宅小取门店管理端'
  }
  // 员工激活
  if (to.path === '/activePage') {
    return next()
  }
  // 权限页面
  if (to.path === '/401') {
    return next()
  }
  if (to.path === '/login') {
    // 如果打开登录页面，判断是否有 token 如果有则进入 home 页面  如果没有就去 login 页面
    if (store.state.token.accessToken) {
      // return next('home')
      return next('/')
    } else {
      return next()
    }
  }
  // 如果 token 存在
  if (store.state.token.accessToken) {
    if (to.meta.permissions) {
      if (!store.state.permissions.includes(to.meta.permissions) && to.meta.permissions !== '') {
        return next('/401')
      }
    }
    next()
  } else { // 如果 token 为空强制跳转到登录页面
    next('/login')
  }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js